export default __webpack_public_path__ + "static/media/biz-services.4a8aff08.svg";